import { CircularProgress, TextField } from '@material-ui/core';

export const TextFieldLoader = ({
  label,
  placeholder,
  fullWidth
}: {
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
}) => {
  return (
    <TextField
      label={label}
      fullWidth={fullWidth}
      placeholder={placeholder}
      InputProps={{
        readOnly: true,
        'aria-readonly': true,
        endAdornment: <CircularProgress color="inherit" size={20} />
      }}
    />
  );
};
